<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_4"></a>This is a work of fiction. All of the characters, organizations,<br/>and events portrayed in this novel are either products<br/>of the author’s imagination or are used fictitiously.</p>
<p class="para"> </p>
<p class="center-para"><span class="smallcaps">STEAL ACROSS THE SKY</span></p>
<p class="para"> </p>
<p class="center-para">Copyright © 2009 by Nancy Kress</p>
<p class="para"> </p>
<p class="center-para">All rights reserved.</p>
<p class="para"> </p>
<p class="center-para">A Tor Book</p>
<p class="center-para">Published by Tom Doherty Associates, LLC</p>
<p class="center-para">175 Fifth Avenue</p>
<p class="center-para">New York, NY 10010</p>
<p class="para"> </p>
<p class="center-para"><a href="http://www.tor-forge.com" target="_blank">www.tor-forge.com</a></p>
<p class="para"> </p>
<p class="center-para">Tor<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="para"> </p>
<p class="center-para">Library of Congress Cataloging-in-Publication Data</p>
<p class="para"> </p>
<blockquote>
<p class="para">Kress, Nancy.</p>
<p class="indent-para">Steal across the sky / Nancy Kress.—1st ed.</p>
<p class="indent-para">       p. cm.</p>
<p class="indent-para">“A Tom Doherty Associates book.”</p>
<p class="indent-para">ISBN-13: 978-0-7653-1986-9</p>
<p class="indent-para">ISBN-10: 0-7653-1986-1</p>
<p class="para">1. Human-alien encounters—Fiction. 2. Life on other planets—Fiction. I. Title.</p>
<p class="para"> </p>
<p class="indent-para">PS3561.R46 S67 2009</p>
<p class="indent-para">813'.54—dc22</p>
<p class="right-para">2008046432</p>
</blockquote>
<p class="para"> </p>
<p class="center-para">First Edition: February 2009</p>
<p class="para"> </p>
<p class="center-para">Printed in the United States of America</p>
<p class="para"> </p>
<p class="center-para">0 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?44c2c16c